export default {
	methods: 
    {		
		nuevoModal(modal)
		{
		  this.updateGlobal({state: 'openModal/modal/value',    data: true });
		  this.updateGlobal({state: 'openModal/modal/title',    data: 'Nuevo Proveedor de monturas'});
		  this.updateGlobal({state: 'openModal/modal/modal',    data: 'Nuevo'});
		  this.updateGlobal({state: 'indexData', data: false});
		},	
	},
}